import { useEffect } from 'react'
import PATHS from '@/routes/paths'
import { isThreadsApiAvailable } from '@/services/chat/threadsApi'

/** @param {object} m */
export function useValidateUrlThread(m) {
  const { activePrimaryKey, urlThreadId, navThreads, navigate } = m
  useEffect(() => {
    if (activePrimaryKey !== 'home') return
    if (!urlThreadId) return
    if (isThreadsApiAvailable()) return
    if (!navThreads.some((t) => t.id === urlThreadId)) {
      navigate(PATHS.HOME, { replace: true })
    }
  }, [activePrimaryKey, urlThreadId, navThreads, navigate])
}
